import React from 'react';
/**
 * `RadioOptions` is a convenience wrapper for rendering a list of radio
 * inputs.
 *
 * It normalises `optionsList` (string[] or `{value,text}[]`) and delegates
 * common layout/label/error rendering to `RadioSelection`.
 */
import RadioSelection from '../../common/Product/RadioSelection';

export type RadioOptionsProps = {
  selectedOption: string;
  errorMessage?: string;
  optionsList: string[] | { value: string; text: string }[];
  name: string;
  label?: string;
  disabled?: boolean;
  setSelectedOption: (value: string) => void;
  vertical?: boolean;
};

const RadioOptions = ({
  selectedOption,
  errorMessage = '',
  optionsList,
  name,
  label,
  disabled,
  setSelectedOption,
  vertical
}: RadioOptionsProps): JSX.Element => {
  const renderOptions = (): JSX.Element[] => {
    return optionsList.map((o, i) => {
      const option = String(typeof o === 'string' ? o : o.value);
      const optionLabel = typeof o === 'string' ? o : o.text || o.value;
      const controlId = `${option.replace(' ', '-')}-${name}-${i}`;

      const wrapperClass = vertical ? '' : 'form-check-inline';

      return (
        <div key={controlId} className={`form-check ${wrapperClass}`}>
          <input
            disabled={disabled}
            data-testid={`test-${controlId}`}
            className='form-check-input'
            type='radio'
            name={name}
            id={controlId}
            value={selectedOption}
            onChange={() => !disabled && setSelectedOption(option)}
            checked={selectedOption === option}
          />
          <label className='form-check-label' htmlFor={controlId}>
            {optionLabel}
          </label>
        </div>
      );
    });
  };

  return (
    <RadioSelection
      show={true}
      selectionName={label ?? ''}
      error={errorMessage}
      fontDisabledClass=''>
      {renderOptions()}
    </RadioSelection>
  );
};

export default RadioOptions;
